import React from "react"
import { Box, BoxProps } from "@chakra-ui/core"
import GatsbyImage, { FluidObject } from "gatsby-image"
import { placeholderImage } from "../../utils"
import styled from "@emotion/styled"

type FluidImageProps = BoxProps & {
  image?: FluidObject | null
  defaultImage?: FluidObject
}

const StyledImage = styled(GatsbyImage)`
  width: 100%;
`

export default function FluidImage({
  image,
  defaultImage = placeholderImage,
  ...props
}: FluidImageProps) {
  return (
    <Box {...props}>
      <StyledImage fluid={image || defaultImage} />
    </Box>
  )
}
